/**
 * Validates a value is an abn number.
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name abn
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null || value === '') {
    return Promise.resolve(null);
  }

  // Validate numbers only first && character length
  const numericRegex = /^[0-9]+$/;
  if (!numericRegex.test(value) || (value && value.length !== 6)) {
    return Promise.resolve('bsb-number-invalid');
  }

  return Promise.resolve(null);
}

module.exports = validate;
